import { Location } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, effect, inject, input, linkedSignal, numberAttribute, signal } from '@angular/core';
import { Mode } from 'src/app/components/consulting-reservation';
import { Step2SimpleComponent } from 'src/app/components/consulting-reservation/step2-simple/step2.component';

@Component({
    selector: 'app-consultation-reservation-no-calendar',
    imports: [
        Step2SimpleComponent
    ],
    templateUrl: './consulting-reservation-no-calendar.component.html',
    styleUrl: './consulting-reservation-no-calendar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsultingReservationNoCalendarComponent {
  readonly #location = inject(Location);

  readonly mode = signal<Mode>('step1');

  readonly lpType = input<string | null>(null);
  readonly discount = input(10, { transform: numberAttribute });
  readonly isCasual = input(false, { alias: 'casual', transform: booleanAttribute });
  readonly completeUrl = input<string>('');

  readonly cities = input('');
  readonly countries = input('');

  protected complete = linkedSignal(() => {
    const completeUrl = this.completeUrl();
    const isCasual = this.isCasual();
    if (completeUrl) {
      return completeUrl;
    }

    return isCasual ? '/ab/light-counseling-complete' : '/ab/counseling-complete';
  });

  constructor() {
    if (!sessionStorage.getItem('counseling')) {
      sessionStorage.setItem('counseling', JSON.stringify({}));
    }

    effect(() => {
      const lpType = this.lpType();
      if (lpType) {
        const data = JSON.parse(sessionStorage.getItem('counseling') ?? '{}');
        data.lpType = lpType;
        data.isCasual = this.isCasual();
        sessionStorage.setItem('counseling', JSON.stringify(data));
      }
    });

    this.#parseQuery();
    this.#location.onUrlChange(() => {
      this.#parseQuery();
    });
  }

  #parseQuery() {
    const params = new URLSearchParams(window.location.search);
    this.mode.set(params.get('step') as Mode ?? 'step1');
  }
}
